import { render, staticRenderFns } from "./DevInventoryList.vue?vue&type=template&id=b2a72a0c&scoped=true&"
import script from "./DevInventoryList.vue?vue&type=script&lang=js&"
export * from "./DevInventoryList.vue?vue&type=script&lang=js&"
import style0 from "./DevInventoryList.vue?vue&type=style&index=0&id=b2a72a0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a72a0c",
  null
  
)

export default component.exports